import type { CompositionSection } from '@medplum/fhirtypes'
import { codeFromCodeableConcept } from '@seen/core/codeableConcept'
import { invariant } from '@seen/core/invariant'
import { ValidatedTool } from '@seen/core/models/validatedTool'
import type { ReactNode } from 'react'

export function ValidatedToolSectionPreview({
  section,
}: {
  section: CompositionSection
}): ReactNode {
  const canonical = codeFromCodeableConcept(section.code)
  const validatedTool = ValidatedTool.buildAll().find(
    (tool) => tool.canonical === canonical
  )
  invariant(validatedTool, `No validated tool found for ${canonical}`)
  return (
    <div className="group flex h-16 max-w-(--container-prose) items-center gap-4 rounded-sm border bg-muted px-4">
      <FileIcon className="text-foreground-tertiary" />
      <div className="flex flex-1 flex-col">
        <p className="line-clamp-1">{validatedTool.name}</p>
        <span className="text-3xs text-foreground-secondary">
          Placeholder. Will display a form in the assessment.
        </span>
      </div>
    </div>
  )
}

function FileIcon({ className }: { className?: string }): ReactNode {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      role="img"
      focusable="false"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 1V6.75C6.75 7.5297 7.34489 8.17045 8.10554 8.24313L8.25 8.25H14V13C14 14.1046 13.1046 15 12 15H4C2.89543 15 2 14.1046 2 13V3C2 1.89543 2.89543 1 4 1H6.75ZM8 1L14 7.03022H9C8.44772 7.03022 8 6.5825 8 6.03022V1Z"
      />
    </svg>
  )
}
